import React from "react"

import styles from "./TermsModal.module.css"
import closeBtn from "../../assets/mobileClose.svg"

function TermsModal({ setTermsOpen, title, text }) {
	
	const closeTerms = () => {
		setTermsOpen(false)
	}

	return (
		<>
			<div className={styles.modalWrap}>
				<div className={styles.termsModal}>
					<div className={styles.modalHeader}>
						<h2>{title}</h2>
						<button type="button" onClick={closeTerms}>
							<img src={closeBtn} alt="팝업 닫기" />
						</button>
					</div>
					<div className={styles.modalText}>{text}</div>
					<div className={styles.modalClose}>
						<button type="button" onClick={closeTerms}>
							닫기
						</button>
					</div>
				</div>
			</div>
		</>
	)
}

export default TermsModal
